module.exports = __webpack_public_path__ + "static/media/title.07d15d96.png";